/* 最新消息共用內容資料：列表與文章內頁皆由此渲染。 */
window.RIEASE_NEWS = [
  {
    slug: 'web-trends-2026',
    title: '2026 網頁系統最新趨勢：從「做一個網站」走向可演進的數位平台',
    category: 'trend',
    categoryLabel: '趨勢觀察',
    date: '2026-07-16',
    displayDate: '2026 / 07 / 16',
    image: 'img/news/web-trends-2026.jpg',
    imageAlt: '由智慧介面、雲端架構與多裝置服務組成的 2026 網頁系統主視覺',
    accentClass: 'accent-lime',
    accent: '#B4D333',
    label: '2026 WEB SYSTEM',
    readingTime: '8 MIN READ',
    description: 'AI Agent、平台工程、Edge AI、可觀測性、供應鏈安全與隱私工程，正在重新定義企業網站與系統的設計方式。',
    deck: '2026 年的重點不只是換框架或追逐新介面，而是讓系統能被 AI 使用、能快速交付、能在端側運算，也能以資安與可觀測性支撐長期營運。',
    takeaways: [
      '網站開始同時服務真人與 AI Agent，資訊架構必須可被機器理解。',
      '平台工程把部署、權限、監控與合規做成團隊可重複使用的能力。',
      '效能、隱私與供應鏈安全不再是上線前檢查，而是架構的預設條件。'
    ],
    sections: [
      {
        title: '趨勢一：網站成為 Agent 可操作的服務入口',
        paragraphs: [
          '搜尋框與選單仍然重要，但它們不再是唯一入口。AI Agent 正在代表使用者查找服務、比較資料、填寫流程與觸發工作，因此系統需要更清楚的語意、穩定的介面與可驗證的權限邊界。',
          '這不等於把所有功能交給聊天機器人，而是把內容、API、身分驗證與操作回饋整理成一致的服務層。人看得到的體驗與機器能理解的結構，必須從同一份需求出發。'
        ],
        bullets: ['結構化內容與清楚的狀態回饋', '可授權、可撤銷的 Agent 操作', '重要步驟保留人工確認', '建立工具與能力的可信探索機制']
      },
      {
        title: '趨勢二到四：平台化、端側 AI 與全鏈路可觀測',
        paragraphs: [
          '當產品持續增加，單一專案式的部署與維運方式很快就會成為瓶頸。平台工程以自助式流程、標準範本與安全護欄，讓團隊在一致規則下更快交付；Edge AI 則讓部分推論留在裝置或瀏覽器，降低延遲與敏感資料外傳的需求。',
          '系統越分散，越需要把前端體驗、API、背景工作與 AI 呼叫串成一條可追蹤的路徑。可觀測性因此從「看伺服器有沒有掛」升級成「看使用者任務在哪一步變慢或失敗」。'
        ],
        bullets: ['可重複使用的部署黃金路徑', '依裝置能力漸進啟用端側推論', 'Logs、Metrics、Traces 使用一致語意', '以真實使用者任務衡量品質']
      },
      {
        title: '趨勢五到六：把供應鏈安全與隱私寫進設計',
        paragraphs: [
          '現代網頁系統大量依賴開源套件、CI/CD 與第三方服務。安全工作因此必須涵蓋依賴來源、建置流程、發布產物與弱點回應，而不只是掃描正式環境。',
          '同時，資料最小化、用途限制、透明告知與可撤回同意，正成為產品決策的一部分。好的 2026 架構會先問「這筆資料真的需要離開裝置嗎？」以及「使用者能否理解並控制它？」再決定技術做法。'
        ],
        bullets: ['建立依賴與產物清單', '保護建置及發布流程', '只收集完成任務必要的資料', '同意、撤回與資料權利同等易用']
      },
      {
        title: '企業現在可以怎麼開始？',
        paragraphs: [
          '不必一次重寫所有系統。先選一條高價值流程，盤點使用者任務、資料流、依賴與營運指標，再用可組合的模組逐步改善。每一次改版都應留下可重用的元件、規則與監控，讓下一個功能比上一個更快、更安全。',
          '真正的趨勢不是更多工具，而是把產品、工程、資安與營運放在同一張藍圖上。這也是企業網站從一次性交付，走向可持續演進數位平台的關鍵。'
        ]
      }
    ],
    sources: [
      { label: 'Web Platform Baseline 2026｜web.dev', url: 'https://web.dev/baseline/2026' },
      { label: 'Agentic Resource Discovery｜Google Developers Blog', url: 'https://developers.googleblog.com/announcing-the-agentic-resource-discovery-specification/' },
      { label: 'Platform Engineering Day 2026｜CNCF', url: 'https://www.cncf.io/blog/2026/03/19/kubecon-cloudnativecon-europe-2026-co-located-event-deep-dive-platform-engineering-day/' },
      { label: 'Web Neural Network API｜W3C', url: 'https://www.w3.org/TR/webnn/' },
      { label: 'OpenTelemetry Semantic Conventions', url: 'https://opentelemetry.io/docs/specs/semconv/' },
      { label: 'Secure DevSecOps Practices 2026｜NIST', url: 'https://www.nist.gov/news-events/news/2026/03/new-live-guidelines-secure-software-development-security-and-operations' }
    ]
  },
  {
    slug: 'riease-iso-27001',
    title: '睿鍶科技通過 ISO 27001 資訊安全管理系統驗證',
    category: 'company',
    categoryLabel: '公司動態',
    date: '2026-07-09',
    displayDate: '2026 / 07 / 09',
    image: 'img/news/iso-27001-riease.jpg',
    imageAlt: '代表資訊安全管理、稽核與持續改善的盾牌主視覺',
    accentClass: 'accent-amber',
    accent: '#FFBC4C',
    label: 'TRUST BY DESIGN',
    readingTime: '5 MIN READ',
    description: '從需求、開發到交付與維運，睿鍶以制度化管理守護客戶資料與每一次系統服務。',
    deck: '通過驗證不是終點，而是把資訊安全的責任、流程與持續改善機制，正式落實在每一個專案生命週期。',
    takeaways: [
      '以風險為基礎管理資訊的機密性、完整性與可用性。',
      '把資安要求納入需求、開發、測試、上線與維運流程。',
      '透過定期檢視與改善，持續回應新的威脅與營運情境。'
    ],
    sections: [
      {
        title: '這張證書代表什麼？',
        paragraphs: [
          'ISO/IEC 27001 是資訊安全管理系統的國際標準，要求組織以可持續運作的制度，識別資訊資產、評估風險、建立控制措施並持續改善。它關注的不只有技術，也包含人員、流程、供應商與營運持續性。',
          '對睿鍶而言，通過驗證代表資訊安全不再只是特定專案的附加要求，而是公司治理與日常工作的共同基準。'
        ]
      },
      {
        title: '把資安放進軟體生命週期',
        paragraphs: [
          '從需求訪談開始，我們即盤點資料類型、使用角色與風險情境；進入設計與開發後，則落實權限最小化、版本控管、測試與變更紀錄。上線後的監控、備份、事件處理與弱點回應，也有明確責任與程序。',
          '制度的價值，在於讓不同專案都能以一致原則做決策，並留下可以被驗證與持續改善的紀錄。'
        ],
        bullets: ['需求階段識別資產與風險', '開發環境及存取權限管理', '上線前測試與變更核准', '事件通報、備援與持續改善']
      },
      {
        title: '對客戶與合作夥伴的承諾',
        paragraphs: [
          '睿鍶長期服務政府、教育、企業與研究機構，系統經常承載重要流程與資料。這次驗證讓既有實務被更完整地制度化，也讓客戶能以共同語言理解我們如何管理資訊安全。',
          '未來我們仍會持續檢視風險、演練應變、強化供應鏈與開發流程，讓每一次交付都同時兼顧功能、體驗與信任。'
        ]
      }
    ],
    sources: [
      { label: 'ISO/IEC 27001:2022｜International Organization for Standardization', url: 'https://www.iso.org/standard/27001' },
      { label: 'Secure Software Development Framework｜NIST', url: 'https://csrc.nist.gov/projects/ssdf' }
    ]
  },
  {
    slug: 'agentic-web-systems',
    title: 'AI Agent 進入企業網站：從聊天視窗到可控的任務執行',
    category: 'ai',
    categoryLabel: 'AI 應用',
    date: '2026-06-26',
    displayDate: '2026 / 06 / 26',
    image: 'img/news/ai-agents.jpg',
    imageAlt: '中央智慧核心協調多個任務節點的 AI Agent 系統',
    accentClass: 'accent-violet',
    accent: '#9A83FF',
    label: 'AGENTIC WEB',
    readingTime: '6 MIN READ',
    description: '下一代企業網站不只回答問題，也能在權限與稽核機制下協助完成查詢、申請與跨系統任務。',
    deck: 'Agent 的價值不在更像人說話，而在能否安全地理解任務、取得正確工具、完成操作並交代過程。',
    takeaways: ['先定義 Agent 可以做什麼，再選模型。', '高風險操作必須有授權、確認與可追溯紀錄。', '內容、API 與權限模型要一起設計。'],
    sections: [
      {
        title: '從回答問題，走向完成任務',
        paragraphs: ['傳統聊天機器人主要提供資訊；Agent 則會拆解目標、選擇工具、呼叫服務並檢查結果。例如查詢案件進度、整理符合條件的資料，或協助完成表單草稿。', '這讓網站從資訊展示層，進一步成為可組合的服務入口；但每多一個可操作能力，也同時增加權限與誤操作風險。']
      },
      {
        title: '三層安全設計不可少',
        paragraphs: ['第一層是能力邊界：Agent 只能看到被允許的工具與資料。第二層是執行護欄：敏感操作需要確認、參數驗證與速率限制。第三層是可追溯性：記錄它為何選擇工具、實際做了什麼，以及結果是否成功。'],
        bullets: ['最小權限與短效授權', '寫入前的人工作業確認', '輸入輸出與工具參數驗證', '完整稽核軌跡與異常回復']
      },
      {
        title: '適合企業的導入順序',
        paragraphs: ['先從資料範圍清楚、結果容易驗證的任務開始，例如內部知識查詢、表單草擬與案件摘要。等到權限、品質評估與監控成熟，再逐步開放跨系統寫入。', 'Agent 不是取代現有系統，而是把散落的操作整理成更自然的任務入口。最好的導入會讓使用者更省步驟，也讓管理者更看得見風險。']
      }
    ],
    sources: [
      { label: 'Agentic Resource Discovery｜Google Developers Blog', url: 'https://developers.googleblog.com/announcing-the-agentic-resource-discovery-specification/' },
      { label: 'How A2A is Building a World of Collaborative Agents｜Google Developers Blog', url: 'https://developers.googleblog.com/how-a2a-is-building-a-world-of-collaborative-agents/' }
    ]
  },
  {
    slug: 'platform-engineering',
    title: '平台工程成為數位服務底座：把交付速度與治理做成同一件事',
    category: 'engineering',
    categoryLabel: '系統工程',
    date: '2026-06-12',
    displayDate: '2026 / 06 / 12',
    image: 'img/news/platform-engineering.jpg',
    imageAlt: '連接雲端、服務與資料節點的平台工程底座',
    accentClass: 'accent-mint',
    accent: '#68EBC8',
    label: 'PLATFORM ENGINEERING',
    readingTime: '6 MIN READ',
    description: '以自助式能力、黃金路徑與安全護欄，降低團隊每次開發、部署與維運都重新摸索的成本。',
    deck: '平台工程不是再成立一個維運部門，而是把常用能力產品化，讓開發團隊能在清楚邊界內自主交付。',
    takeaways: ['平台的使用者是內部產品與開發團隊。', '黃金路徑提供快速預設，也保留合理擴充空間。', '平台成效要以交付時間、失敗率與採用率衡量。'],
    sections: [
      { title: '為什麼專案越多，交付反而越慢？', paragraphs: ['當每個團隊各自挑選工具、建立部署流程、處理權限與監控，相同問題會被重複解決。專案一多，技術差異與維運負擔便迅速累積。', '平台工程把這些跨專案的共同能力整理為可重複使用的服務，讓團隊把時間放在真正有差異的業務需求。'] },
      { title: '一條好的黃金路徑長什麼樣？', paragraphs: ['好的黃金路徑包含範本、自動化流程與治理預設，例如建立服務、取得測試環境、部署、回滾、監控與權限申請。它應該讓常見需求很容易完成，例外需求也有清楚出口。'], bullets: ['服務與環境自助建立', '安全掃描與測試預設整合', '標準化監控與事件通知', '文件、範例與責任邊界清楚'] },
      { title: '從一個痛點開始，而不是先買工具', paragraphs: ['先找出交付流程中最耗時、最常出錯的一段，與實際使用平台的團隊共同設計，再逐步擴充。沒有被採用的平台，再完整也只是另一套負擔。', '當部署、安全與可觀測性成為平台能力，新的 Web 服務與 AI 應用才能在一致規則下快速成長。'] }
    ],
    sources: [
      { label: 'What is platform engineering?｜CNCF', url: 'https://www.cncf.io/blog/2025/11/19/what-is-platform-engineering/' },
      { label: 'Platform Engineering Day 2026｜CNCF', url: 'https://www.cncf.io/blog/2026/03/19/kubecon-cloudnativecon-europe-2026-co-located-event-deep-dive-platform-engineering-day/' }
    ]
  },
  {
    slug: 'edge-ai-web',
    title: 'Edge AI 與瀏覽器端推論：更即時、更私密的網頁體驗',
    category: 'ai',
    categoryLabel: 'AI 應用',
    date: '2026-05-29',
    displayDate: '2026 / 05 / 29',
    image: 'img/news/edge-ai.jpg',
    imageAlt: '在裝置端執行 AI 推論並連接多個終端設備',
    accentClass: 'accent-coral',
    accent: '#FF8C75',
    label: 'EDGE INTELLIGENCE',
    readingTime: '5 MIN READ',
    description: '讓部分 AI 推論在瀏覽器與裝置上完成，可降低網路延遲、雲端成本與敏感資料傳輸。',
    deck: '當裝置具備更成熟的 CPU、GPU 與 NPU，Web 應用開始能在靠近使用者的位置完成即時推論。',
    takeaways: ['端側推論適合即時、個人化與敏感資料情境。', '需依裝置能力提供模型與功能降級。', '模型更新、快取與資源用量同樣需要治理。'],
    sections: [
      { title: '為什麼要把推論移到使用者身邊？', paragraphs: ['影像、聲音或文字若先上傳雲端再處理，會受到網路品質、延遲與資料傳輸風險影響。端側推論能讓部分任務在瀏覽器或裝置內完成，回應更即時，也減少敏感資料離開本機的需求。', '常見情境包括背景降噪、影像分類、即時輔助、內容摘要與弱網環境的智慧功能。'] },
      { title: 'WebNN 帶來什麼改變？', paragraphs: ['W3C 的 Web Neural Network API 提供跨硬體的神經網路推論抽象層，讓框架能使用 CPU、GPU 或專用加速器。2026 年規格持續朝互通性、Transformer 支援與隱私防護成熟。', '不過規格仍在演進，正式產品必須採取漸進增強：能使用加速就啟用，不能使用時則切換小模型、雲端服務或一般功能。'], bullets: ['先檢查裝置能力再載入模型', '模型量化與分段下載', '限制記憶體、耗電與執行時間', '保留可理解的替代流程'] },
      { title: '端側不等於沒有風險', paragraphs: ['模型檔仍可能暴露、輸入仍需驗證，硬體能力查詢也可能帶來指紋辨識風險。設計時應限制可辨識資訊、在安全環境執行，並清楚告知使用者資料如何被處理。', '端側 AI 的最佳價值，是在正確任務上平衡體驗、隱私與成本，而不是把所有推論都搬到瀏覽器。'] }
    ],
    sources: [
      { label: 'Web Neural Network API｜W3C Candidate Recommendation Draft', url: 'https://www.w3.org/TR/webnn/' },
      { label: 'WebNN Get Started｜W3C Web Machine Learning', url: 'https://webmachinelearning.github.io/webnn-getstarted' }
    ]
  },
  {
    slug: 'full-stack-observability',
    title: '可觀測性 2.0：從系統告警回到真實使用者任務',
    category: 'engineering',
    categoryLabel: '系統工程',
    date: '2026-05-15',
    displayDate: '2026 / 05 / 15',
    image: 'img/news/observability.jpg',
    imageAlt: '多條資料訊號匯入可觀測性分析核心',
    accentClass: 'accent-magenta',
    accent: '#F06BC8',
    label: 'OBSERVABILITY',
    readingTime: '5 MIN READ',
    description: '把前端體驗、API、背景任務與 AI 呼叫串成同一條可追蹤路徑，才能快速回答問題發生在哪裡。',
    deck: '監控告訴你已知問題是否發生；可觀測性則讓團隊能從輸出訊號，理解未預期的系統狀態。',
    takeaways: ['以使用者任務建立服務指標。', 'Logs、Metrics、Traces 與 Profiles 要能互相對照。', '資料量不是目標，能縮短定位與恢復時間才是。'],
    sections: [
      { title: '只有主機正常，並不代表服務正常', paragraphs: ['CPU 與記憶體都正常，使用者仍可能卡在登入、付款或送出表單。現代系統橫跨瀏覽器、API、佇列、第三方服務與 AI 模型，單點監控很難說明完整體驗。', '因此觀測設計要從關鍵任務出發，確認每一步的成功率、延遲與失敗原因。'] },
      { title: '用一致語意串起訊號', paragraphs: ['OpenTelemetry 的語意慣例為 traces、metrics、logs、profiles 與資源提供共同命名方式。當服務名稱、錯誤類型與操作名稱一致，團隊才能跨工具關聯同一事件。'], bullets: ['前端產生並傳遞追蹤識別', 'API 與背景工作保持上下文', '重要業務事件使用一致欄位', '敏感資料在收集前遮罩或排除'] },
      { title: '把觀測資料變成改善循環', paragraphs: ['好的告警指向使用者影響，也附上足夠上下文讓團隊採取行動。每次事故後，再把缺少的訊號、模糊的責任或高噪音規則回饋到系統設計。', '可觀測性最終要降低平均偵測與修復時間，並讓產品團隊看見哪些體驗值得優先改善。'] }
    ],
    sources: [
      { label: 'OpenTelemetry Semantic Conventions 1.43.0', url: 'https://opentelemetry.io/docs/specs/semconv/' },
      { label: 'Semantic Conventions Concepts｜OpenTelemetry', url: 'https://opentelemetry.io/docs/concepts/semantic-conventions/' }
    ]
  },
  {
    slug: 'software-supply-chain',
    title: '軟體供應鏈安全：每一個套件、建置與發布都要能被信任',
    category: 'security',
    categoryLabel: '資訊安全',
    date: '2026-04-24',
    displayDate: '2026 / 04 / 24',
    image: 'img/news/supply-chain.jpg',
    imageAlt: '在安全檢核下依序通過建置與發布流程的軟體產物',
    accentClass: 'accent-amber',
    accent: '#FFBC4C',
    label: 'SECURE DELIVERY',
    readingTime: '6 MIN READ',
    description: '現代系統由大量外部元件組成，安全範圍必須從程式碼延伸到開發環境、CI/CD 與發布證明。',
    deck: '產品的安全強度，不只取決於自己寫的程式，也取決於依賴從哪裡來、如何建置，以及誰能改變發布結果。',
    takeaways: ['建立元件與依賴的可視性。', '保護開發、建置與發布環境。', '把弱點回應與更新責任納入日常流程。'],
    sections: [
      { title: '風險不只存在正式環境', paragraphs: ['攻擊者可能鎖定開發者帳號、套件來源、建置腳本或發布憑證，在軟體上線前就植入問題。只掃描正式網站，無法涵蓋整條供應鏈。', '第一步是知道系統用了哪些元件、版本、來源與授權，並能在弱點發生時快速回答受影響範圍。'] },
      { title: '把 SSDF 落到 CI/CD', paragraphs: ['NIST SSDF 將實務分為準備組織、保護軟體、產出安全軟體與回應弱點。2026 年的最新示範更強調把這些要求標準化、自動化到 DevSecOps 管線。'], bullets: ['鎖定與驗證依賴來源', '隔離並最小化建置權限', '掃描程式碼、套件與映像', '保存產物來源與發布紀錄'] },
      { title: '安全護欄不能拖慢交付', paragraphs: ['如果安全流程只能靠人工追表單，團隊很容易繞過它。應把常見檢核設成平台預設，在風險超過門檻時才升級人工審查。', '有效的供應鏈治理會讓安全證據自動產生、責任清楚，並在發現弱點時快速定位、修補與重新發布。'] }
    ],
    sources: [
      { label: 'Secure Software Development Framework｜NIST', url: 'https://csrc.nist.gov/projects/ssdf' },
      { label: 'Secure DevSecOps Practices 2026｜NIST', url: 'https://www.nist.gov/news-events/news/2026/03/new-live-guidelines-secure-software-development-security-and-operations' }
    ]
  },
  {
    slug: 'privacy-by-design',
    title: 'Privacy by Design：把隱私從告知條款變成系統能力',
    category: 'security',
    categoryLabel: '資訊安全',
    date: '2026-04-10',
    displayDate: '2026 / 04 / 10',
    image: 'img/news/iso-27701.jpg',
    imageAlt: '資料在透明邊界與分層控管下安全流動的隱私工程主視覺',
    accentClass: 'accent-blue',
    accent: '#2EC5FF',
    label: 'PRIVACY ENGINEERING',
    readingTime: '5 MIN READ',
    description: '資料最小化、用途限制、透明告知與權利操作，需要在資料模型與產品流程裡真正做得到。',
    deck: '隱私不是上線前補一頁政策，而是從收集、使用、保存、分享到刪除都有清楚目的與控制。',
    takeaways: ['只收集完成使用者目標所需的資料。', '目的、同意與資料生命週期必須一致。', '查詢、更正、撤回與刪除要成為可用功能。'],
    sections: [
      { title: '從「有告知」走向「可控制」', paragraphs: ['使用者真正需要的不是更長的條款，而是在正確時間理解誰會取得哪些資料、用於什麼目的，以及如何改變決定。透明告知只是起點，系統還必須支援後續控制。', 'W3C 2025 隱私原則把資料最小化、用途限制、透明與同意撤回等要求，整理為網站與 Web 技術可採用的設計方向。'] },
      { title: '把原則落到資料流', paragraphs: ['每一筆個人資料都應能回答來源、目的、保存期限、存取角色與分享對象。若無法回答，就很難在需求改變或使用者提出權利要求時正確處理。'], bullets: ['欄位層級記錄收集目的', '預設採最短合理保存期限', '敏感資料分級與存取稽核', '同意撤回同步停止後續處理'] },
      { title: '隱私與體驗可以同時變好', paragraphs: ['少收資料能縮短表單，延後權限詢問能讓情境更清楚，本機處理則可能同時降低延遲與傳輸風險。把隱私視為設計限制，往往會得到更簡潔的流程。', '隱私工程的成熟度，最終體現在系統能否以低成本證明「只做了承諾的事」，並讓使用者容易行使選擇。'] }
    ],
    sources: [
      { label: 'Privacy Principles｜W3C Statement', url: 'https://www.w3.org/TR/privacy-principles/' },
      { label: 'New Privacy Principles for a more trustworthy web｜W3C', url: 'https://www.w3.org/blog/2025/new-privacy-principles-for-a-more-trustworthy-web/' }
    ]
  }
];